import { render } from "./KioskCreateAccount.vue?vue&type=template&id=0df4d2d5&scoped=true"
import script from "./KioskCreateAccount.vue?vue&type=script&lang=js"
export * from "./KioskCreateAccount.vue?vue&type=script&lang=js"

import "./KioskCreateAccount.vue?vue&type=style&index=0&id=0df4d2d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df4d2d5"]])

export default __exports__